import React from "react";
import BaseModal from "../BaseModal";
import { SolvedWordRow } from "../../GameGrid";
import CountdownToNextPuzzle from "../../CountdownToNextPuzzle";
import { PuzzleDataContext } from "../../../providers/PuzzleDataProvider";
import { Separator } from "../../ui/separator";
import OtherGamesList from "../../OtherGamesList";
import { getGameResultsIcon, getGameResultsTitle } from "../../../lib/game-helpers";

function GameLostModal({ open }) {
  const { gameData } = React.useContext(PuzzleDataContext);

  return (
    <BaseModal
      icon={getGameResultsIcon(false)}
      title={getGameResultsTitle(false)}
      initiallyOpen={open}
      showActionButton={false}
    >
      <div className="grid gap-y-2 px-4">
        <p className="text-lg font-[500] text-center">
          Aqui está a solução:
        </p>
        {gameData.map((obj) => (
          <SolvedWordRow key={obj.category} {...obj} />
        ))}
      </div>
      <p className="font-semibold mt-4 text-center">Não desista! Volte amanhã para jogar novamente.</p>
      <CountdownToNextPuzzle />
      <Separator className="my-4"/>
      <OtherGamesList />
    </BaseModal>
  );
}

export default GameLostModal;
